import React from 'react';

import { CssBaseline } from '@mui/material';
import { Head } from '@react-email/head';
import { Html } from '@react-email/html';
import { type TTemplate } from '@wp-block-builder/package';
import { WaypointDocumentStoreProvider } from '@wp-block-builder/stores/WaypointDocumentStore';
import { useGlobalBodyBackgroundColor } from '@wp-block-builder/stores/WaypointDocumentStore/useGlobalStyles';

import BodyWrapper from '../document-layout/BodyWrapper';
import CanvasBlock from '../document-layout/CanvasBlock';
import FooterLine from '../document-layout/FooterLine';
import GlobalSharedStyle from '../document-layout/GlobalSharedStyle';
import Preheader from '../document-layout/Preheader';

import ReadOnlyBlock from './Block';

type Props = {
  configuration: TTemplate;
  variables: Record<string, unknown>;
  skipLiquid: boolean;
  footerBody?: null | JSX.Element;
};
export default function ReadOnlyMessage({ footerBody, configuration, variables, skipLiquid = false }: Props) {
  const blocks = configuration.blocks ?? [];

  const renderFooterLine = () => {
    if (skipLiquid || !footerBody) {
      return <></>;
    }
    return <FooterLine>{footerBody}</FooterLine>;
  };

  return (
    <WaypointDocumentStoreProvider configuration={configuration} variables={variables} skipLiquid={skipLiquid}>
      <Html lang="en" dir="ltr">
        <Head>
          <CssBaseline />
          <GlobalSharedStyle />
        </Head>
        <HtmlBody>
          <BodyWrapper>
            <Preheader template={configuration.preheaderTemplate} skipLiquid={skipLiquid} />
            <CanvasBlock>
              {blocks.map((block, i) => (
                <ReadOnlyBlock key={i} block={block} />
              ))}
            </CanvasBlock>
            {renderFooterLine()}
          </BodyWrapper>
        </HtmlBody>
      </Html>
    </WaypointDocumentStoreProvider>
  );
}

function HtmlBody({ children }: { children: JSX.Element }) {
  const backgroundColor = useGlobalBodyBackgroundColor();
  return <body style={{ backgroundColor }}>{children}</body>;
}
